import {
  REMUNERATION_NAVIGATION_ACTIONS,
  REMUNERATION_FORM_MODE,
} from './constants';
import { ActionTypes } from './actions';

const initialState: REMUNERATION_FORM_MODE = REMUNERATION_FORM_MODE.list;

const selectedRemunerationModeNavigationReducer = (
  state: REMUNERATION_FORM_MODE = initialState,
  action: ActionTypes,
): REMUNERATION_FORM_MODE => {
  switch (action.type) {
    case REMUNERATION_NAVIGATION_ACTIONS.SET_MODE:
      return action.payload;
    case REMUNERATION_NAVIGATION_ACTIONS.RESET_MODE:
      return initialState;
    default:
      return state;
  }
};

export default selectedRemunerationModeNavigationReducer;
